














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AxRow extends Vue {
  @Prop({ type: String })
  width!: string;

  @Prop({ type: String })
  height!: string;

  @Prop({ type: String, default: 'hidden' })
  overflow!: string;

  @Prop({ type: String, default: 'nowrap' })
  wrap!: string;

  @Prop({ type: String, default: 'baseline' })
  alignContent!: string;
}
